@if (freeBetToken$ | async; as freeBet) {
    <bs-freebet-stake [freeBetToken]="freeBet" [isLinear]="true"></bs-freebet-stake>
} @else {
    <ms-stake
        *ngIf="stake$ | async as stake"
        [stake]="getStakeAsStr(stake.stake)"
        [errors]="hasStakeError$"
        [keypadId]="keypadId"
        [numpadSource]="numpadSource"
        [adornmentStart]="adornmentText$ | async"
        [emptyCharacter]="messages.linear.StakePlaceholder"
        [focusPlaceholder]="focusPlaceholder"
        [disabled]="isDisabled"
        [useStakeFieldCursor]="useStakeFieldCursor"
        (stakeChanged)="setStake($event)">
    </ms-stake>
}
